import { combineReducers } from "redux";
import authReducer from "./authReducer";
import modalReducer from "./modalReducer";
import sidebarReducer from "./sidebarReducer";
import subscriptionReducer from "./subscriptionReducer";
import straightAestheticRemodelReducer from "./dealAnalyzerReducers/straightAestheticRemodelReducer";
import dealAnalyzerQuestionnaireReducer from "./dealAnalyzerReducers/dealAnalyzerQuestionnaireReducer";
import dealReportsReducer from "./dealAnalyzerReducers/dealReportsReducer";
import inHouseReportNotificationsReducer from "./inHouseReportNotificationsReducer";
import reportsNavReducer from "./reportsNavReducer";

export default combineReducers({
  modals: modalReducer,
  sidebar: sidebarReducer,
  auth: authReducer,
  subscriptions: subscriptionReducer,
  straightAestheticRemodel: straightAestheticRemodelReducer,
  dealAnalyzerQuestionnaires: dealAnalyzerQuestionnaireReducer,
  reports: dealReportsReducer,
  inHouseReportNotifications: inHouseReportNotificationsReducer,
  reportsNav: reportsNavReducer,
});
